import * as React from 'react';
import {useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import YesNo from '../../../../components/YesNo';
import ManagementTable from '../../components/ManagementTable';
import CountryForm from '../../forms/CountryForm';

const Countries = () => {
  const services = useContext(ServiceContext);
  return (
    <ManagementTable
      title="Countries"
      addTitle="Add New Country"
      editTitle="Edit Country"
      columns={[
        {title: 'Name', field: 'name'},
        {title: 'Code', field: 'code'},
        {title: 'Default?', field: 'is_default', render: data => <YesNo value={data.is_default}/>},
      ]}
      loadData={async (query) => services.country.getTableCountries(query)}
      renderForm={(props, country, onSaved) => (
        <CountryForm
          {...props}
          country={country ?? {}}
          onSaved={onSaved}
        />
      )}
    />
  )
}

export default Countries;
